import { useGlobal } from './GlobalContext'
import Login from './Components/Login'
import Interface from './Interface'
function App() {
  const { loggedIn } = useGlobal()
  return loggedIn ? <Interface /> : <Login />
}

export default App
